import { Router } from '@angular/router';
import { Settings } from '../../../../lib/app.constant';

/** Shared navigation rules for bell dropdown + Notifications page. */
export const NOTIFICATION_MODULE_ROUTE_MAP: Record<number, string> = {
  200: '/master-data/business-process',
  115: '/map/code-list',
  116: '/map/code-list/codelist-library',
  125: '/document-tracker',
  380: '/master-data/email-template',
  90: '/file-profile/custom/json',
  105: '/file-profile/custom/json',
  85: '/file-profile/standard',
  360: '/map/map-error-code-list',
  93: '/map/library',
  94: '/map/library',
  96: '/partners/connectivity',
  92: '/partners/contract',
  80: '/partners/setup',
  370: '/master-data/regex-management',
  10: '/master-data/role',
  330: '/master-data/status-management',
  50: '/master-data/users',
  60: '/master-data/user-activity-log',
  350: '/master-data/customer',
  320: '/master-data/column-settings',
};

/** Dedicated PrimeIcons glyph per module (all verified against installed primeicons). */
export const NOTIFICATION_MODULE_ICON_MAP: Record<number, string> = {
  200: 'pi-cog', // Business Process
  115: 'pi-list', // Conversion Code List
  116: 'pi-database', // Code List Library
  125: 'pi-send', // Document Tracker
  380: 'pi-envelope', // Email Template
  90: 'pi-file-edit', // Custom File Definition
  105: 'pi-file', // File Definition
  85: 'pi-table', // Standard File Definition
  360: 'pi-exclamation-circle', // Map Error List
  93: 'pi-folder', // Map Library
  94: 'pi-sitemap', // Map Setup
  96: 'pi-share-alt', // Partner Connectivity
  92: 'pi-briefcase', // Partner Contract
  80: 'pi-users', // Partner Setup
  370: 'pi-code', // Regex Management
  10: 'pi-key', // Role Management
  330: 'pi-tag', // Status Management
  50: 'pi-user', // User Management
  60: 'pi-history', // User Activity Log
  350: 'pi-building', // Customer
  320: 'pi-sliders-h', // Column Settings
};

export function getNotificationModuleIcon(moduleId: number | string): string {
  return NOTIFICATION_MODULE_ICON_MAP[Number(moduleId)] ?? 'pi-bell';
}

export function isDeleteNotification(item: any): boolean {
  return (item?.message || '').toLowerCase().includes('delete');
}

export function getNotificationModuleName(moduleId: number | string): string {
  const id = Number(moduleId);
  const entry = Object.entries(Settings.Module).find(
    ([key, value]) => value === id
  );
  return entry ? entry[0].replaceAll('_', ' ') : '';
}

export function canNavigateNotification(item: any): boolean {
  if (!item) return false;
  // Export-type / non-row notifications carry reference_id 0/"0"/"" — nothing to filter to.
  // reference_id is text: integer PKs as decimal strings, UUID PKs (Business Process) as UUID text.
  const ref = item?.reference_id;
  if (ref === 0 || ref === '0' || ref === '' || ref == null) return false;
  // Deleted-row notifications have nothing left to navigate to.
  if (isDeleteNotification(item)) return false;
  const moduleId = Number(item.module_id);
  return !!NOTIFICATION_MODULE_ROUTE_MAP[moduleId];
}

export function navigateNotificationToMap(router: Router, item: any): void {
  const moduleId = Number(item.module_id);
  const route = NOTIFICATION_MODULE_ROUTE_MAP[moduleId];
  if (!route) {
    return;
  }
  const queryParams: any = {};
  if (item.reference_id !== 0 && item.reference_id !== '0' && item.reference_id !== '' && item.reference_id != null) {
    queryParams.ref_id = String(item.reference_id);
  }
  router.navigate([route], { queryParams });
}
